<template>
	<div>
		<!-- dialog body -->
		<v-dialog v-model="visible" persistent max-width="700px" v-if="dialogTask && dialogTask.id">
			<v-card>
				<v-card-title class="justify-center">
					<h3> Task Details </h3>
					<v-btn icon absolute top right color="dark" @click="closeTaskDialog()">
						<b>x</b>
					</v-btn>
				</v-card-title>

				<v-card-text style="" class="px-1">
						<v-container>
							<v-row class="my-1">
								<v-col cols="2" md="1" sm="1" align="right" class="pr-0">
									<v-checkbox 
										v-model="dialogTask.completed"
										@click.stop="handleCheckbox(dialogTask)"
										:disabled="(!isLoading && dialogTask.creator && !(currentUser.id == dialogTask.assignee.id) && !(currentUser.id == dialogTask.creator.id) && !currentUser.privileges.canCompleteAllTasks)"	
										class="task-details-checkbox my-2"
										hide-details
									></v-checkbox>
								</v-col>

								<v-col cols="10" md="7" sm="11" align-self="center">
									<v-row no-gutters class="text-left">
										<v-col cols="12" align-self="center">
											<span class="font-weight-bold">
												{{ dialogTask.title }}
											</span>
											<div style="display: inline-block;">
												<v-icon
												@click="triggerEditTask(dialogTask, 0)"
												class="ml-2"
												right
												v-if="dialogTask.creator && ((currentUser.privileges.canManageAssignedTasks && dialogTask.assignee.id == currentUser.id) || (dialogTask.creator.id == currentUser.id || currentUser.privileges.canManageAllTasks))"
												>
													mdi-pencil
												</v-icon>
												<v-icon
													@click="triggerDeleteTask(dialogTask)"
													class="ml-2 red--text text--darken-4"
													right				
													v-if="dialogTask.creator && ((currentUser.privileges.canManageAssignedTasks && dialogTask.assignee.id == currentUser.id) || (dialogTask.creator.id == currentUser.id || currentUser.privileges.canManageAllTasks))"
												>
													mdi-delete
												</v-icon>
											</div>
										</v-col>
										
										<v-col cols="12" align-self="center">
											<v-icon small>
												mdi-calendar
											</v-icon>
											<span :class="checkIsBefore(dialogTask.due_datetime) ? 'red--text font-weight-medium': 'green--text font-weight-medium'">
												{{ moment(dialogTask.due_datetime).format('DD MMM h:mm a') }}
											</span>
											<div v-for="tag in dialogTask.task_tags" :key="tag.id" class="d-inline-block">
												<span :style="`color: ${tag.color}; font-weight: 500; margin-right: 4px`">
													{{ tag.name }}
												</span>
											</div>
										</v-col>
									</v-row>
								</v-col>

								<v-col cols="12" md="4" sm="12" align-self="center">
									<v-row justify="center">
										<v-col cols="3" sm="3" v-if="dialogTask.assignee && dialogTask.assignee.image" align="right" class="px-0 py-0">
											<v-img  :src="`${dialogTask.assignee.image}`" style="height:40px; width: 40px; border-radius: 50%"></v-img>
										</v-col>

										<v-col v-if="showAssigneeName && dialogTask.assignee && dialogTask.assignee.full_name" align-self="center" id="assignee-full-name">
											<h3 class="font-weight-medium text-left" style="font-weight: 400; font-size: 1em">
												{{ dialogTask.assignee.full_name }}
											</h3>
										</v-col>
									</v-row>
								</v-col>
							</v-row>
							
							<v-row v-if="dialogTask.creator && dialogTask.creator.full_name">
								<v-col sm="1" md="1" class="py-0"></v-col>
								<v-col cols="12" sm="6" md="6">
									<p :class="$vuetify.breakpoint.width < 600? 'grey--text text--darken-1 text-center py-0' : 'text-left grey--text text--darken-1 py-0'" style="font-size:0.95em">
										Created by: {{ dialogTask.creator.full_name + ' (' + dialogTask.creator.username + ")" }}
									</p>
								</v-col>
								<v-spacer></v-spacer>
							</v-row>

							<v-row>
								<v-spacer></v-spacer>
								<v-col cols="10"  class="text-left black--text pt-0">
									{{ dialogTask.description }}
								</v-col>
								<v-spacer></v-spacer>
							</v-row>

							<v-divider class=" my-2"></v-divider>

							<v-tabs v-model="tab" show-arrows v-if="dialogTask">
								<v-tab>Sub-Tasks {{ dialogTask.sub_tasks ? `(${dialogTask.sub_tasks.length})` : '(0)' }}</v-tab>
								<v-tab @click="scrollToBottom();handleTour();">Comments {{ commentsList ? `(${commentsList.length})` : '(0)' }}</v-tab>
							</v-tabs>

							<v-tabs-items v-model="tab">
								<!-- Sub-tasks tab -->
								<v-tab-item>
									<v-container v-if="dialogTask.sub_tasks && dialogTask.sub_tasks.length" id="subtask-container">
										<v-container v-for="child in dialogTask.sub_tasks" :key="child.id" class="px-0 py-0">
											<v-row class="">
												<v-col cols="2" md="1" sm="1" align="right" class="pr-0">
													<v-checkbox 
														v-model="child.completed"
														class="task-details-checkbox my-2"
														hide-details
														:disabled="(!isLoading && child && child.creator && !(currentUser.id == child.assignee.id) && !(currentUser.id == child.creator.id) && !(dialogTask.creator.id == currentUser.id) && !currentUser.privileges.canCompleteAllTasks)"	
														@click="handleCheckbox(child)"
													></v-checkbox>
												</v-col>

												<v-col cols="10" md="7" sm="11" align-self="center">
													<v-row no-gutters class="text-left">
														<v-col cols="12" align-self="center">
															<span class="font-weight-bold">
																{{ child.title }}
															</span>
															<div style="display: inline-block;">
																<v-icon
																	@click="triggerEditTask(child,1)"
																	class="ml-2"
																	right
																	v-if="dialogTask.creator && ((currentUser.privileges.canManageAssignedTasks && child.assignee.id == currentUser.id) || (dialogTask.creator.id == currentUser.id) || (child.creator.id == currentUser.id || currentUser.privileges.canManageAllTasks))"
																>
																	mdi-pencil
																</v-icon>
																<v-icon
																	@click="triggerDeleteTask(child)"
																	class="ml-2 red--text text--darken-4"
																	right				
																	v-if="dialogTask.creator && ((currentUser.privileges.canManageAssignedTasks && child.assignee.id == currentUser.id) || (dialogTask.creator.id == currentUser.id) || (child.creator.id == currentUser.id || currentUser.privileges.canManageAllTasks))"
																>
																	mdi-delete
																</v-icon>
															</div>
														</v-col>
														
														<v-col cols="12" align-self="center">
															<v-icon small>
																mdi-calendar
															</v-icon>
															<span :class="checkIsBefore(child.due_datetime) ? 'red--text font-weight-medium': 'green--text font-weight-medium'">
																{{ moment(child.due_datetime).format('DD MMM h:mm a') }}
															</span>
															<div v-for="tag in child.task_tags" :key="tag.id" class="d-inline-block">
																<span :style="`color: ${tag.color}; font-weight: 500; margin-right: 4px`">
																	{{ tag.name }}
																</span>
															</div>
														</v-col>
													</v-row>
												</v-col>

												<v-col cols="12" md="4" sm="12" align-self="center">
													<v-row justify="center">
														<v-col cols="3" sm="3" v-if="child.assignee && child.assignee.image" align="right" class="px-0 py-0">
															<v-img  :src="`${child.assignee.image}`" style="height:40px; width: 40px; border-radius: 50%"></v-img>
														</v-col>

														<v-col v-if="showAssigneeName && child.assignee && child.assignee.full_name" align-self="center">
															<h3 class="font-weight-medium text-left" style="font-weight: 400; font-size: 1em">
																{{ child.assignee.full_name }}
															</h3>
														</v-col>
													</v-row>
												</v-col>
												<v-row v-if="child.creator && child.creator.full_name">
													<v-col sm="1" md="1" class="py-0"></v-col>
													<v-col cols="12" sm="6" md="6">
														<p :class="$vuetify.breakpoint.width < 600? 'grey--text text--darken-1 text-center py-0' : 'text-left grey--text text--darken-1 py-0 pl-3'" style="font-size:0.95em">
															Created by: {{ child.creator.full_name + ' (' + child.creator.username +')' }}
														</p>
													</v-col>
													<v-spacer></v-spacer>													
												</v-row>
											</v-row>
										</v-container>
									</v-container>

									<v-container v-else>
										<h3 v-if="this.currentUser.privileges.canAddSubTasks">
											No sub-tasks available! Add a sub-task using the button below.
										</h3>
									</v-container>

									<v-row justify="start" class="my-1">
										<v-col cols="12" md="4" v-if="((currentUser.id == dialogTask.creator.id) || (currentUser.privileges.canAddSubTasks))">
											<v-btn
												color="primary"
												text
												@click="triggerSubTaskDialog()"
												:disabled="isLoading"
											>
												<span class="text-decoration-underline" id="add-subtask-btn">
													+ Add sub-task
												</span>
											</v-btn>
										</v-col>
									</v-row>
								</v-tab-item>

								<!-- comments tab -->
								<v-tab-item>
									<v-container v-if="commentsList && commentsList.length">
										<div class="scrollable-window" id="scrollWindow">
											<div
												:items="commentsList"
												v-for="(item,index) in commentsList"
												:key="item.id"
											>
												<v-row class="mt-1 mx-1">
													<v-col cols="3" md="1" sm="3" align-self="center">
														<!-- <v-row justify="center"> -->
															<div v-if="item.author && item.author.image" >
																<img :src="`${item.author.image}`" style="border-radius: 50%; width: 30px; height: 30px"/>
															</div>
														<!-- </v-row> -->
													</v-col>

													<v-col cols="8" md="8" sm="6" align-self="center" class="py-1">
														<div :class="$vuetify.breakpoint.smAndDown ? 'text-left font-weight-bold' : 'text-left font-weight-bold'" v-if="item.author">
															{{ item.author.full_name }}
															<v-icon
																class="ml-1 red--text text--darken-4"
																@click="triggerCommentDelete(item, index)"
																v-if="(currentUser.privileges.canDeleteAllComments || currentUser.id==item.author.id)"
															>
																mdi-delete
															</v-icon>
														</div>
													</v-col>

													<v-col cols="12" md="3" sm="3" align-self="center" class="pt-1">
														<v-tooltip bottom>
															<template v-slot:activator="{ on }">
																<div v-on="on">
																	<div v-if="item.created">
																		{{ moment(item.created).fromNow() }}
																	</div>
																</div>
															</template>
															<span> {{ moment(item.created).format('lll') }} </span>
														</v-tooltip>
													</v-col>
												</v-row>

												<v-row class="my-1 mx-1">
													<v-col cols="12" align-self="center">
														<!-- comment description -->
														<div class="text-left font-weight-medium" v-if="item.description" v-html="item.description" v-linkified>
														</div>
													</v-col>
												</v-row>
											</div>
										</div>
									</v-container>

									<div class="my-1">
										<v-textarea
											placeholder="Add a comment..."
											outlined
											dense
											auto-grow
											class="mt-1 mx-2 rounded-input"
											rows="1"
											row-height="28"
											v-model="commentBody.description"
											maxlength="180"
											counter
											ref="commentBox"
											@keydown.enter.prevent="submitComment()"
										>
										</v-textarea>

										<v-row justify="end" class="">
											<v-col cols="12" md="4">
												<v-btn
													color="primary"
													outlined
													:disabled="isLoading"
													@click="submitComment()"
													class="my-1"
												>
													Add Comment
												</v-btn>
											</v-col>
										</v-row>
									</div>
								</v-tab-item>

							</v-tabs-items>
						</v-container>
				</v-card-text>
			</v-card>

			<!-- snackbar -->
			<v-snackbar v-model="snackbar.visible" :color="snackbar.color" multi-line style="z-index: 3000">
				{{ snackbar.message }}
				<template v-slot:action="{ attrs }">
					<v-btn dark text v-bind="attrs" @click="snackbar.visible = false">
						Close
					</v-btn>
				</template>
			</v-snackbar>
		</v-dialog>

		<DeleteConfirmationDialog
			:title="`Are you sure you want to delete this ${toDeleteTask ? 'task' : 'comment'} ?`"
			:description="`This ${toDeleteTask ? 'task along with it\'s sub-tasks (if any)' : 'comment'} will be permanently deleted!`"
			:visible="showDeleteConfirmation"
			@deleteObject="deleteItem"
		/>

		<AddTaskDialog
			:visible="showSubTaskDialog"
			:title="!itemType ? (is_editing ? 'Edit Task' : 'Add Task') : (is_editing ? 'Edit Sub-task' : 'Add Sub-Task')"
			:type="itemType"
			:task="itemToEdit"
			:parentId="parentId"
			:is_editing="is_editing"
			@closeAddEditTaskDialog="closeAddTaskDialog"
			@changeTaskInDialog="changeTaskInDialog"
		/>
	</div>
</template>

<script>
import api from "@api/index"
import { mapActions, mapGetters } from "vuex"
import endpoints from "@api/repository"
import Helper from "@utils/misc"
import moment from "moment"
import AddTaskDialog from "@components/task/AddTaskDialog.vue"
import DeleteConfirmationDialog from '@components/widgets/dialogs/DeleteConfirmationDialog.vue'
import TourHelper from "@utils/tour_helper";


export default {
	name: 'TaskDetails',

	props: {
		"visible": {
			type: Boolean,
			default: function(){
				return false
			},
		},
		"dialogTask": {
			type: Object,
			default: function(){
				return  {} 
			}
		},
		"taskIndex": {
			type: Number,
			default: null
		},
		"showAssigneeName": {
			type: Boolean,
			default: function(){
				return false;
			}
		}
	},

	components: {
		AddTaskDialog,
		DeleteConfirmationDialog
	},

	data() {
		return {
			moment: moment,
			snackbar: {
				visible: false,
				message: "",
				color: "dark",
			},
			rules: {
				required: (value) => !!value || "Required",
			},
			is_editing: false,
			tab: 0,
			showDeleteConfirmation: false,
			showSubTaskDialog: false,
			toDeleteComment: false,
			toDeleteTask: false,

			itemToEdit: null,
			itemType: null,		// type 0 for task, 1 for subtask
			parentId: null,
			commentsList: null,

			commentBody: {
				author: null,
				description: null,
				task: null
			},

			selectedTask: {},
			selectedComment: null,

			undoTrigger: false,
			detectChanges: 0
		}
	},

	computed: {
		...mapGetters([
			"currentUser",
			"accessToken",
			"isLoading",
			"currentInstitution",
		]),

		apiEssentials() {
			return {
				accessToken: this.accessToken,
				setLoading: this.setLoading,
				handleErrorsFunction: this.handleApiErrors,
			};
		},
	},

	methods: {
		...mapActions(["setLoading"]),

		handleTour() {
        var steps = [];
        steps.push({id: '1', title: "Comments", description: "This Section shows all comments from various people who're assigned in this task.", videoLink: "https://youtube.com"});
        TourHelper.startTour(this, "tasks__details", steps);
    },

		// handle api errors
		async handleApiErrors(err) {
			this.setLoading(false);
			console.log(err);
			if (err.response) {
				this.snackbar.message = "Unable to process request";
				this.snackbar.color = "error";
				this.snackbar.visible = true;
			}
		},

		scrollToBottom(){
			setTimeout(() => {
				if(this.commentsList && this.commentsList.length && this.tab==1){
					var scrollableWindow = document.getElementById('scrollWindow')
					scrollableWindow.scrollTop = scrollableWindow.scrollHeight
				}
			}, 100);
			
		},

		// get the selected task's comments via api call
		async fetchTaskComments() {
			var ID = this.dialogTask.id
			var url = Helper.addUrlParams(endpoints.taskComments, [`task=${ID}`])
			var response = await api.call(this.apiEssentials, url)
			if(response) {
				this.commentsList = response
				this.scrollToBottom();
			}
		},

		// send completion status via api on clicking checkbox
		async handleCheckbox(item) {
			this.snackbar.message = `Task has been ${item.completed ? 'completed' : 'incompleted'}`;
			this.snackbar.color = "success";
			this.snackbar.timeout = 5000;
			this.snackbar.visible = true;
			var newItem = await this.changeTaskCompletionStatus(item.id, item.completed)

			// emit to parent to replace the task with updated version
			this.$emit('replaceTask', newItem)
		},

		async changeTaskCompletionStatus(id, completed){
			var url = endpoints.tasks + `${id}/`
			var response = await api.call(this.apiEssentials, url, api.Methods.PATCH, { "completed": completed })
			if(response){
				return response;
			}
		},

		checkIsBefore(date){
			var dueDate = moment(date)
			var currentDate = moment()
			return dueDate.isBefore(currentDate)
		},

		// when Add Sub-task is clicked
		triggerSubTaskDialog() {
			this.parentId = this.dialogTask.id;
			this.is_editing = false
			this.showSubTaskDialog = true
			this.itemType = 1
		},
		
		// edit task, sub-task (on icon click)
		triggerEditTask(item, type) {
			this.is_editing = true
			this.showSubTaskDialog = true
			this.itemToEdit = Helper.clone(item)
			this.itemType = type
		},


		// delete task, sub-task (on icon click)
		triggerDeleteTask(task) {
			this.toDeleteTask = true
			this.selectedTask = task;
			this.showDeleteConfirmation = true
		},

		triggerCommentDelete(comment, index) {
			this.toDeleteComment = true
			this.selectedComment = comment
			this.selectedComment.index = index
			this.showDeleteConfirmation = true
		},

		// perform DELETE action via api call
		async deleteItem(confirm) {
			if(confirm) {
				if(this.toDeleteTask) {
					var url = endpoints.tasks + `${this.selectedTask.id}/`
					var response = await api.call(this.apiEssentials, url, api.Methods.DELETE)

					if(response){
						this.snackbar.visible = true
						this.snackbar.message = "Item successfully deleted"
						this.snackbar.color = "success"
						this.showDeleteConfirmation = false
						
						// emit to ViewTasks to remove the deleted task from the list
						this.$emit("deletedTaskFromDialog", this.selectedTask.id, this.selectedTask.is_sub_task, this.selectedTask.parent)
						
						if(!this.selectedTask.is_sub_task) {
							this.closeTaskDialog()
						}
					}
				}
				else if(this.toDeleteComment) {
					url = endpoints.taskComments + `${this.selectedComment.id}/`
					response = await api.call(this.apiEssentials, url, api.Methods.DELETE)
					if(response) {
						this.snackbar.visible = true
						this.snackbar.message = "Comment deleted successfully"
						this.snackbar.color = "success"

						this.showDeleteConfirmation = false
						this.commentsList.splice(this.selectedComment.index, 1);
					}
				}
			}
			else {
				this.showDeleteConfirmation = false
			}

			this.toDeleteTask = false
			this.toDeleteComment = false
		},

		// post new comment via api call
		async submitComment() {
			this.commentBody.description = this.commentBody.description.trim()

			if(this.commentBody.description.length > 0) {
				var url = endpoints.taskComments
				var response = await api.call(this.apiEssentials, url, api.Methods.POST, this.commentBody)

				if(response) {
					this.snackbar.message = "Comment added successfully!"
					this.snackbar.visible = true
					this.snackbar.color = "success"
					this.$refs.commentBox.reset()
					this.fetchTaskComments()
				}
			}
			else{
				this.snackbar.message="Comment cannot be empty!";
				this.snackbar.color="error"
				this.snackbar.visible = true;
			}
		},

		changeTaskInDialog(id){
			// notify parent to update task details in dialog
			this.$emit('changeTaskInDialog', id);
		},

		closeTaskDialog() {
			this.tab = 0
			this.commentBody = {
				description: null,
				author: this.currentUser.id,
				task: null
			}
			this.snackbar.visible = false
			this.commentsList = null
			this.$emit('closeTaskDetailsDialog')
		},

		closeAddTaskDialog() {
			this.showSubTaskDialog = false;
		},
	},

	watch: {
		visible: {
			async handler() {
				if(this.visible) {
					this.fetchTaskComments()
					this.commentBody.task = this.dialogTask.id
				}
			}
		},
	},

	created() {
		this.commentBody.author = this.currentUser.id
	},

}
</script>

<style scoped>

	.v-list-item {
		justify-content: space-between;
	}
	.wrap-text {
		-webkit-line-clamp: unset !important;
		white-space: normal;
	}
	.tooltip {
		display: block;
		white-space: normal;
		word-wrap: break-word;
		text-overflow: ellipsis;
	}

	.scrollable-window{
		max-height: 180px;
		overflow-y: auto;
	}

</style>

<style>
	.task-details-checkbox .v-input__slot {
		justify-content: flex-end;
	}
</style>